<div class="p-grid marginzero p-justify-even footerContainer">
  <div class="p-col-12 p-sm-4">
      <div class="footer-left-side" [innerHTML]="footerLeftSide.content"></div>
  </div>
  <div class="p-col-12 p-sm-4">
    <div class="p-grid p-dir-col" style="height: 100%; margin:auto">
      <a routerLink="/regulamin">{{ 'terms_and_conds' | translate }}</a>
      <a routerLink="/polityka-prywatnosci">{{ 'privacy' | translate }}</a>
      <a routerLink="/onas">{{ 'about_us' | translate }}</a>
      <a routerLink="/sposobyplatnosci">{{ 'payments_methods' | translate }}</a>
      <a routerLink="/jakkupowac">{{ 'how_to_buy' | translate }}?</a>
    </div>
  </div>
</div>
<div class="p-grid marginzero p-justify-even" style="background: #e1e1e1;">
  <div>
    <div [innerHTML]="footerBottomSide.content"></div>
  </div>
</div>
